// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Details_wrapperComponent__JmGFJ","price":"Details_price__CZKhf","title":"Details_title__HWuwh","label":"Details_label__SadBr"};